import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { baseColors } from '../../../Themes/colors';
var PILL_CONFIG = [
    { key: 'Failed', label: 'Failed', dotColor: baseColors.errorPreset[10], activeColor: baseColors.errorPreset[20], activeBg: baseColors.errorPreset[30] },
    { key: 'Processing', label: 'Processing', dotColor: baseColors.warningPreset[10], activeColor: baseColors.warningPreset[20], activeBg: baseColors.warningPreset[30] },
    { key: 'Completed', label: 'Completed', dotColor: baseColors.successPreset[40], activeColor: baseColors.successPreset[50], activeBg: baseColors.successPreset[60] },
    { key: 'Deleted', label: 'Deleted', dotColor: baseColors.greyPreset[30], activeColor: baseColors.greyPreset[10], activeBg: baseColors.greyPreset[45] },
];
var Pill = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== 'isActive' && prop !== 'isDisabled' && prop !== 'activeColor' && prop !== 'activeBg'; },
})(function (_a) {
    var isActive = _a.isActive, isDisabled = _a.isDisabled, activeColor = _a.activeColor, activeBg = _a.activeBg;
    return ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 14px',
        borderRadius: 4,
        border: "1px solid ".concat(isActive ? activeColor : baseColors.greyPreset[40]),
        backgroundColor: isActive ? activeBg : baseColors.fullWhite,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.5 : 1,
        userSelect: 'none',
        transition: 'background-color 0.15s ease, border-color 0.15s ease',
    });
});
var ResubmitStatusPills = function (_a) {
    var counts = _a.counts, activeStatus = _a.activeStatus, onSelect = _a.onSelect;
    return (React.createElement(Stack, { direction: "row", spacing: 1.5, flexWrap: "wrap", useFlexGap: true }, PILL_CONFIG.map(function (pill) {
        var isActive = activeStatus === pill.key;
        var count = counts[pill.key];
        var paddedCount = count || 0;
        var pillNode = (React.createElement(Pill, { key: pill.key, isActive: isActive, isDisabled: pill.disabled, activeColor: pill.activeColor, activeBg: pill.activeBg, onClick: function () { return !pill.disabled && onSelect(pill.key); } },
            React.createElement(Box, { sx: {
                    width: 8,
                    height: 8,
                    borderRadius: '4px',
                    backgroundColor: pill.dotColor,
                    flexShrink: 0,
                } }),
            React.createElement(Typography, { sx: {
                    fontSize: 14,
                    fontWeight: 600,
                    color: isActive ? pill.activeColor : baseColors.darkPreset[10],
                    whiteSpace: 'nowrap',
                } },
                pill.label,
                " (",
                paddedCount,
                ")")));
        return pill.disabled ? (React.createElement(Tooltip, { key: pill.key, title: "Not available yet", placement: "top", arrow: true },
            React.createElement("span", null, pillNode))) : pillNode;
    })));
};
export default ResubmitStatusPills;
